import React from "react";
import { useState } from "react";
import { Col, Grid } from "antd";
import NewsCard from "../NewsCard";
import { Row, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import { StyledPagination } from "./styled";

const { useBreakpoint } = Grid;

// Helper function to normalize article structure for both fetched and reported news
const normalizeArticle = (article: any, index: number) => {
  // Always normalize to ensure consistent structure
  // Use _id or article_id as the primary identifier
  const primaryId = article._id || article.article_id || article.id;

  // For reported news without ID, generate a stable ID using created_at timestamp
  // This ensures the same article always gets the same ID across renders
  let fallbackId = primaryId;
  if (!primaryId) {
    // Use created_at (or created timestamp) + first 30 chars of title for uniqueness
    const timestamp = article.created_at || article.createdAt || "";
    const titlePart =
      article.title?.substring(0, 30).replace(/[^a-zA-Z0-9]/g, "_") ||
      "untitled";
    fallbackId = `manual_${timestamp}_${titlePart}`;
  }

  return {
    ...article,
    // Ensure article_id is always set
    article_id: fallbackId,
    articlePubDate: article.articlePubDate || article.created_at || "",
    genre: article.genre || article.genres || "General",
    source: article.source || article.created_by || "Manual Report",
    language: article.language || "English",
  };
};

export const NewsBox = ({ news, addedCards, add, newsCardView }: any) => {
  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const screens = useBreakpoint();

  const totalItems = news.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };

  const startItem = (currentPage - 1) * itemsPerPage;
  const endItem = currentPage * itemsPerPage;

  return (
    <Content
      style={{
        height: "100%",
        minHeight: "73vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Row
        justify={screens.xs ? "center" : "start"}
        align="top"
        style={{ margin: screens.xs ? "0px" : "5px" }}
      >
        {news.length ? (
          news?.slice(startItem, endItem).map((value: any, index: number) => (
            // <Row
            //   justify="start"
            //   align="middle"
            //   style={{ margin: screens.xs ? "0px" : "5px" }}
            // >
            <Col
              lg={6}
              key={value.article_id || value._id || `news-${startItem + index}`}
            >
              <NewsCard
                news={normalizeArticle(value, startItem + index)}
                addedCards={addedCards}
                add={add}
                newsCardView={newsCardView}
              />
            </Col>

            // </Row>
          ))
        ) : (
          <Row justify={"center"} style={{ height: "100%", width: "100%" }}>
            <Typography.Text
              style={{
                fontSize: "40px",
                fontFamily: "Lato",
                fontWeight: "700",
                marginTop: "250px",
              }}
            >
              No News Found!
            </Typography.Text>
          </Row>
        )}
      </Row>
      {news.length ? (
        <Row justify="center" align="bottom" style={{ marginBottom: "40px" }}>
          {/* pagination on page one is also displayed */}
          {totalPages > 1 || currentPage === 1 ? (
            <StyledPagination
              current={currentPage}
              total={totalItems}
              pageSize={itemsPerPage}
              onChange={onPageChange}
              showSizeChanger={false}
            />
          ) : null}
        </Row>
      ) : (
        ""
      )}
    </Content>
  );
};

export default NewsBox;
